import { IconButton } from '@mui/material';
import { getMediaIconMui } from './getMediaIcon';
import { FC } from 'react';
interface Props {
  media: { url: string; type: string };
  customFunction?: () => void;
}

export function urlSanitization(url: string): string {
  if (!url.startsWith('https://') && !url.startsWith('http://')) {
    url = 'https://' + url;
  }

  const domainPart = url.replace('https://', '');

  const hasWWW = domainPart.startsWith('www.');
  const domainParts = domainPart.split('.');
  const hasSubdomain = domainParts.length > 2 && !hasWWW;

  if (!hasWWW && !hasSubdomain) {
    url = 'https://www.' + domainPart;
  }

  return url;
}
const CovaloMediaButton: FC<Props> = ({ media, customFunction }) => {
  return (
    <div key={media.url} role="button" aria-label={`Link to ${media.type}`}>
      {!customFunction ? (
        <IconButton
          color="primary"
          size="small"
          LinkComponent={'a'}
          sx={{ p: 0 }}
          href={
            //for email were not using and http link but a mailto link
            media.type === 'email' ? media.url : urlSanitization(media.url)
          }
          target={'_blank'}
          rel="noopener noreferrer"
        >
          {getMediaIconMui(media.type)}
        </IconButton>
      ) : (
        <IconButton onClick={customFunction} color="primary" size="small">
          {getMediaIconMui(media.type)}
        </IconButton>
      )}
    </div>
  );
};

export default CovaloMediaButton;
